import React from "react";
import { withRouter } from "react-router-dom";
import authenticationService from "../auth/AuthenticationService";
import geolocationService from "../services/GeolocationService";

class login extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoginBtndisabled: true,
      loginText: "Please wait...",
      userName: "",
      password: "",
      phone: "",
      authCode: "",
      latitude: null,
      longitude: null,
      erroruserName: false,
      errorpassword: false,
      errorPhone: false,
      errorauthCode: false,
      errorLocation: false,
    };
    this._isMounted = false; // Track if the component is still mounted
    // redirect to home if already logged in
    if (authenticationService.isAuthenticated()) {
      this.props.history.push("/prod/bmr");
    }
  }

  componentDidMount() {
    this._isMounted = true;
    // Fetch the user's location on component mount
    geolocationService
      .getCurrentLocation()
      .then((location) => {
        if (this._isMounted) {
          // Check if component is still mounted before updating state
          // console.log("latitude:" + location.latitude);
          // console.log("longitude:" + location.longitude);
          this.setState({
            latitude: location.latitude,
            longitude: location.longitude,
            isLoginBtndisabled: false, // Enable login once coordinates are available
            loginText: "Login",
          });
        }
      })
      .catch((error) => {
        if (this._isMounted) {
          // Only update state if still mounted
          this.setState({ errorLocation: error });
        }
      });
  }

  componentWillUnmount() {
    this._isMounted = false; // Component is unmounted, cancel state updates
  }

  render() {
    return (
      <div>
        <input
          id="username"
          type="text"
          onBlur={(e) => {
            this.updateUserName(e.target.value);
          }}
          className={
            "form-control" + (this.state.erroruserName ? " is-invalid" : "")
          }
          placeholder="Username "
        />
        {this.state.erroruserName ? (
          <div className="invalid-feedback">{this.state.erroruserName}</div>
        ) : null}
        <br />
        <input
          id="pass"
          type="password"
          onBlur={(e) => {
            this.updatePassword(e.target.value);
          }}
          className={
            "form-control" + (this.state.errorpassword ? " is-invalid" : "")
          }
          placeholder="Password "
        />
        <br />
        <input
          id="phoneNo"
          type="text"
          onBlur={(e) => {
            this.updatePhoneNo(e.target.value);
          }}
          className={
            "form-control" + (this.state.errorPhone ? " is-invalid" : "")
          }
          placeholder="Phone "
        />
        <br />
        <input
          type="text"
          onBlur={(e) => {
            this.updateAuthCode(e.target.value);
          }}
          className={
            "form-control" + (this.state.errorauthCode ? " is-invalid" : "")
          }
          placeholder="Auth Code "
        />
        <br />
        {this.state.errorLocation && (
          <div className="invalid-feedback">{this.state.errorLocation}</div>
        )}
        <button
          className="btn btn-success"
          disabled={this.state.isLoginBtndisabled}
          onClick={this.login.bind(this)}>
          {this.state.loginText}
        </button>
      </div>
    );
  }

  updateUserName(value) {
    this.setState({
      userName: value,
    });
  }

  updatePassword(value) {
    this.setState({
      password: value,
    });
  }

  updatePhoneNo(value) {
    this.setState({
      phone: value,
    });
  }

  updateAuthCode(value) {
    this.setState({
      authCode: value,
    });
  }

  login() {
    // console.log("Login Button Clicked...");
    this.setState({ isLoginBtndisabled: true });
    this.setState({
      erroruserName: false,
      errorpassword: false,
      errorPhone: false,
      errorauthCode: false,
    });

    if (this.state.latitude && this.state.longitude) {
      authenticationService
        .login(
          document.getElementById("username").value,
          document.getElementById("pass").value,
          document.getElementById("phoneNo").value,
          // this.state.userName,
          // this.state.password,
          // this.state.phone,
          this.state.authCode,
          this.state.latitude,
          this.state.longitude
        )
        .then(
          (user) => {
            const { from } = this.props.location.state || {
              from: { pathname: "/prod/bmr" },
            };
            this.props.history.push(from);
            authenticationService.setCompCord(
              this.state.latitude,
              this.state.longitude
            );
            authenticationService.setUserCord(
              this.state.latitude,
              this.state.longitude
            );
            localStorage.setItem("compLatitude", this.state.latitude);
            localStorage.setItem("compLongitude", this.state.longitude);
          },
          (error) => {
            this.setState({ isLoginBtndisabled: false });
            let errorMessage;
            if (error === "error.http.401") {
              errorMessage = "Invalid! Username or Password";
            } else {
              errorMessage = error.toString();
            }
            this.setState({
              erroruserName: errorMessage,
              isLoginBtndisabled: false,
            });
          }
        );

      // this.props.history.push('/'+this.props.location);
    } else {
      this.setState({ errorLocation: "Location is required for login" });
    }
  }
}

export default withRouter(login);
